import { useEffect } from "react";
import { useMenu } from "../Menu/useMenu";
import { useSearch } from "../Search/useSearch";

export function useKeyboard() {
  const { openSearch } = useSearch();
  const { closeMenu } = useMenu();

  useEffect(() => {
    const handleKeys = (event: { key: string }) => {
      if (event.key === "Escape") {
        closeMenu();
      }
    };

    document.addEventListener("keydown", handleKeys);
    return () => document.removeEventListener("keydown", handleKeys);
  }, [closeMenu, openSearch]);
}
